import { ReduxAction } from '../actions';
import { OptimizelyState } from './state';

const INITIAL_STATE: OptimizelyState = {
  enabledFeatures: [],
};

// Overview of how Optimizely works on engine/client:
// https://miro.com/app/board/o9J_kqXfGTc=/
export const Optimizely = (
  state: OptimizelyState = INITIAL_STATE,
  action: ReduxAction
): OptimizelyState => {
  switch (action.type) {
    case 'READ_OPTIMIZELY_FEATURES_FROM_DOM':
    case 'GET_ENABLED_OPTIMIZELY_FEATURES_SUCCESS':
      return {
        ...state,
        enabledFeatures: action.features,
      };
    default: {
      return state;
    }
  }
};
